import React, { useContext } from 'react'
import { Router } from '@reach/router'

import AuthContext from '../../services/firebase/AuthContext';
import CustomerAppRoutes from './CustomerAppRoutes'; 
import SignUpCompletePage, { SignUpCompletePagePath } from '../../features/auth/SignUpCompletePage';
import VerifyEmailPage, { VerifyEmailPagePath } from '../../features/auth/VerifyEmailPage';
import SelectFirmPage, { SelectFirmPagePath } from '../../features/solicitors/SelectFirmPage';
import SelectOrganizationPage, { SelectOrganizationPagePath } from '../../features/organizations/SelectOrganizationPage';

const LimboAppRoutes = () => {
    const { currentUser } = useContext(AuthContext);

    if (currentUser.organizationId === '0000') {
        return (
            <Router>
                <SignUpCompletePage default={currentUser.verified} path={SignUpCompletePagePath} />
                <VerifyEmailPage default={!currentUser.verified} path={VerifyEmailPagePath} />
                {/* Sign up solicitor / law firm */}
                <SelectFirmPage path={SelectFirmPagePath} />
                <SelectOrganizationPage path={SelectOrganizationPagePath} />
            </Router>
        );
    }
    else {
        return <CustomerAppRoutes />;
    }

}

export default LimboAppRoutes;